<mf-page title="Nueva Cuenta">
  <mf-bank-account
    [hideVerifyButton]="true"
    (close)="close()"
    (save)="save($event)" />
</mf-page>
